import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IExperience } from "../experienceModel";

export const getAllExperiences = createAsyncThunk(
  "Experience/FindAllExperience",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/FindAllExperience`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Experiences:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createExperience = createAsyncThunk(
  "Experience/InsertExperience",
  async (ExperienceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/InsertExperience`,
        ExperienceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Experience:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateExperience = createAsyncThunk(
  "Experience/UpdateExperience",
  async (ExperienceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/UpdateExperience`,
        ExperienceData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Experience:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteExperience = createAsyncThunk(
  "Experience/DeleteExperience",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/DeleteExperience`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Experience :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getExperienceByID = createAsyncThunk(
  "Experience/FindByIDExperience",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/FindByIDExperience`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Image: result.Image,
        Description: result.Description,
        SequenceNo: result.SequenceNo,
        IsActive: result.IsActive ? 1 : 2,
      } as IExperience;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Experience :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveExperiences = createAsyncThunk(
  "Experience/FindAllActiveExperience",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Experience/FindAllActiveExperience`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Experience:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveExperience = createAsyncThunk(
  "Experience/ActiveInActiveExperience",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/ActiveInActiveExperience`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Experience :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ExperienceImageUpload = createAsyncThunk(
  "Experience/ExperienceImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Experience/ExperienceImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Experience Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
